import React, {useEffect, useRef, useState} from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContentText from "@mui/material/DialogContentText";
import DialogContent from "@mui/material/DialogContent";



export default function DialogCompButton({text, head, open, setOpen}) {


  const handleClickOpen = () => {
    setOpen(true);
  }
  const handleClose = () => {
    setOpen(false);
  }


  return (
    <div>

      <Dialog
        open={open}
        onClose={handleClose}
        scroll={"paper"}
      >
        <DialogTitle id="scroll-dialog-title">{head}</DialogTitle>
        <DialogContent dividers>
          <DialogContentText
            tabIndex={-1}
          >
            {text}
          </DialogContentText>
        </DialogContent>

      </Dialog>
    </div>
  );
}





